export type SocialLink = {
  name: 'Instagram' | 'Facebook' | 'TikTok'
  href: string
}

export const socialHandle = '@twentymilehouse'

export const socialLinks: SocialLink[] = [
  { name: 'Instagram', href: 'https://www.instagram.com/twentymilehouse' },
  { name: 'Facebook', href: 'https://www.facebook.com/twentymilehouse' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@twentymilehouse' },
]
